import React, { useEffect } from "react";
import { Box } from "@mui/material";
import MembershipNavbar from "./MembershipNavbar";
import MobileBottomNav from "./MobileBottomNav";
import { MembershipWrapper } from "./MembershipStyles";
import { Outlet } from "react-router-dom";
import { SearchProvider } from "./SearchContext";
import MembershipSearchOverlay from "./MembershipSearchOverlay";

const MembershipLayout: React.FC = () => {
  // Clear any legacy FaceFlow onboarding flag that may be stuck in localStorage
  useEffect(() => {
    localStorage.removeItem("ff_new_signup");
  }, []);

  return (
    <SearchProvider>
      <MembershipWrapper>
        <MembershipNavbar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
        <MobileBottomNav />
        <MembershipSearchOverlay />
      </MembershipWrapper>
    </SearchProvider>
  );
};

export default MembershipLayout;
